import { ACTIONS } from '../Constants';

const initialWelcomeState = {
    returnToInfoSlide: false
};

const welcomeReducer = (state = initialWelcomeState, action) => {
    switch (action.type) {
        case ACTIONS.RETURN_TO_INFO_SLIDE: {
            return {
                ...state,
                returnToInfoSlide: action.flag
            };
        }
        default:
            return state;
    }
};

export default welcomeReducer;
